import account from './account';
import app from './app';
import budgets from './budgets';
import debug from './debug';
import modals from './modals';
import notifications from './notifications';
import prefs from './prefs';
import profile from './profile';
import queries from './queries';
import tutorial from './tutorial';
import user from './user';

export default {
  app,
  queries,
  account,
  debug,
  profile,
  prefs,
  modals,
  notifications,
  budgets,
  tutorial,
  user
};
